module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "m-l-50 m-t-30 dimensionalChart"
  }, [_c('common-config', {
    attrs: {
      "id": _vm.id,
      "form": _vm.form,
      "inputList": _vm.inputList,
      "isLimit": false
    }
  }, [_c('template', {
    slot: "self-config"
  }, [_c('div', {
    staticClass: "area"
  }, [_c('span', [_vm._v("图表配置")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("显示的图表")]), _vm._v(" "), _c('div', [_c('el-checkbox-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.display.display_list),
      expression: "form.display.display_list"
    }],
    domProps: {
      "value": (_vm.form.display.display_list)
    },
    on: {
      "input": function($event) {
        _vm.form.display.display_list = $event
      }
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "table"
    }
  }, [_vm._v("表格")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "bar"
    }
  }, [_vm._v("柱状图")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "pie"
    }
  }, [_vm._v("饼图")])]), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.showLayout
    }
  }, [_vm._v("页面布局")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("表格显示方向")]), _vm._v(" "), _c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.display.direction),
      expression: "form.display.direction"
    }],
    domProps: {
      "value": (_vm.form.display.direction)
    },
    on: {
      "input": function($event) {
        _vm.form.display.direction = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("横向")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("纵向")])])])])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "area m-t-20"
  }, [_c('span', [_vm._v("筛选区配置")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("类型")]), _vm._v(" "), _c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.search.type),
      expression: "form.search.type"
    }],
    domProps: {
      "value": (_vm.form.search.type)
    },
    on: {
      "input": function($event) {
        _vm.form.search.type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 10
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 20
    }
  }, [_vm._v("年")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 30
    }
  }, [_vm._v("月")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 40
    }
  }, [_vm._v("日")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 50
    }
  }, [_vm._v("年范围")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 60
    }
  }, [_vm._v("月范围")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 70
    }
  }, [_vm._v("日范围")])]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("默认值")]), _vm._v(" "), _c('div', [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.search.default.from),
      expression: "form.search.default.from"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "默认时间变量"
    },
    domProps: {
      "value": (_vm.form.search.default.from)
    },
    on: {
      "input": function($event) {
        _vm.form.search.default.from = $event
      }
    }
  }), _vm._v("\n            ~\n            "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.search.default.to),
      expression: "form.search.default.to"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "默认时间变量"
    },
    domProps: {
      "value": (_vm.form.search.default.to)
    },
    on: {
      "input": function($event) {
        _vm.form.search.default.to = $event
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_vm._v("* 时间变量说明：Y代表年，M代表月，D代表天，h代表时，m代表分，s代表秒，+1代表往前加一个单位，-1代表往后减一个单位，支持小数；可使用&进行多公式连接。")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_vm._v("例如：D+1 代表明天，M+1代表下个月，h+1代表一个小时后，m+10代表十分钟后，s+30代表30秒后，不填即当前时间")])])])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "area m-t-20"
  }, [_c('div', {
    staticClass: "m-t-10 table-container"
  }, [_c('el-form-item', {
    attrs: {
      "label": "表格配置",
      "prop": "table"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.table,
      "border": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "指标名称"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.name),
            expression: "scope.row.name"
          }],
          attrs: {
            "placeholder": "指标名称"
          },
          domProps: {
            "value": (scope.row.name)
          },
          on: {
            "input": function($event) {
              scope.row.name = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "220"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.setConfig(scope.$index, scope.row)
            }
          }
        }, [_vm._v("配置")]), _vm._v(" "), (scope.$index != 0) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.moveTr(scope.$index, 0)
            }
          }
        }, [_vm._v("上移")]) : _vm._e(), _vm._v(" "), (scope.$index != _vm.form.table.length - 1) ? _c('el-button', {
          attrs: {
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.moveTr(scope.$index, 1)
            }
          }
        }, [_vm._v("下移")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteRow(scope.$index, _vm.form.table)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addCol()
      }
    }
  }, [_vm._v("添加指标")])])])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "area m-t-20"
  }, [_c('span', [_vm._v("柱状图")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "图类型"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.type),
      expression: "form.bar.type"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.bar.type)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.type = $event
      }
    }
  }, _vm._l((_vm.barType), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.value,
        "value": item.type
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色方案"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.color),
      expression: "form.bar.color"
    }],
    attrs: {
      "placeholder": "请选择活动区域"
    },
    domProps: {
      "value": (_vm.form.bar.color)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.color = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "深色",
      "value": "#2F4554"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "浅色",
      "value": "#3398DB"
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图表标题"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.show_title),
      expression: "form.bar.show_title"
    }],
    domProps: {
      "value": (_vm.form.bar.show_title)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.show_title = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("显示")])]), _vm._v(" "), (_vm.form.bar.show_title == 1) ? _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.title),
      expression: "form.bar.title"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.bar.title)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.title = $event
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图表子标题"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.show_sub_title),
      expression: "form.bar.show_sub_title"
    }],
    domProps: {
      "value": (_vm.form.bar.show_sub_title)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.show_sub_title = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("显示")])]), _vm._v(" "), (_vm.form.bar.show_sub_title == 1) ? _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.sub_title),
      expression: "form.bar.sub_title"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.bar.sub_title)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.sub_title = $event
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据标签"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.show_data_label),
      expression: "form.bar.show_data_label"
    }],
    domProps: {
      "value": (_vm.form.bar.show_data_label)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.show_data_label = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("自定义")])]), _vm._v(" "), (_vm.form.bar.show_data_label == 2) ? _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.data_label),
      expression: "form.bar.data_label"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.bar.data_label)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.data_label = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_vm._v("*自定义标签：{a}（系列名称），{b}（类目值），{c}（数值）+ 单位(可空) "), _c('br'), _vm._v("如：'{a} <br /> {b} : {c}元'")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图例显示"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.legend_type),
      expression: "form.bar.legend_type"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.bar.legend_type)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.legend_type = $event
      }
    }
  }, _vm._l((_vm.legendType), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.value,
        "value": item.type
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "坐标轴"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.show_axis),
      expression: "form.bar.show_axis"
    }],
    domProps: {
      "value": (_vm.form.bar.show_axis)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.show_axis = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("显示")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "网格线"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bar.show_grid),
      expression: "form.bar.show_grid"
    }],
    domProps: {
      "value": (_vm.form.bar.show_grid)
    },
    on: {
      "input": function($event) {
        _vm.form.bar.show_grid = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("显示")])])])])]), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "area m-t-20"
  }, [_c('span', [_vm._v("饼图")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "图类型"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.type),
      expression: "form.pie.type"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.pie.type)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.type = $event
      }
    }
  }, _vm._l((_vm.pieType), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.value,
        "value": item.type
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色方案"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.color),
      expression: "form.pie.color"
    }],
    attrs: {
      "placeholder": "请选择活动区域"
    },
    domProps: {
      "value": (_vm.form.pie.color)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.color = $event
      }
    }
  }, [_c('el-option', {
    attrs: {
      "label": "深色",
      "value": "深色"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "浅色",
      "value": "浅色"
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图表标题"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.show_title),
      expression: "form.pie.show_title"
    }],
    domProps: {
      "value": (_vm.form.pie.show_title)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.show_title = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("显示")])]), _vm._v(" "), (_vm.form.pie.show_title == 1) ? _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.title),
      expression: "form.pie.title"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.pie.title)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.title = $event
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图标子标题"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.show_sub_title),
      expression: "form.pie.show_sub_title"
    }],
    domProps: {
      "value": (_vm.form.pie.show_sub_title)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.show_sub_title = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("显示")])]), _vm._v(" "), (_vm.form.pie.show_sub_title == 1) ? _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.sub_title),
      expression: "form.pie.sub_title"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.pie.sub_title)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.sub_title = $event
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据标签"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.show_data_label),
      expression: "form.pie.show_data_label"
    }],
    domProps: {
      "value": (_vm.form.pie.show_data_label)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.show_data_label = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("自定义")])]), _vm._v(" "), (_vm.form.pie.show_data_label == 2) ? _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.data_label),
      expression: "form.pie.data_label"
    }],
    staticClass: "w-200",
    attrs: {
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.form.pie.data_label)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.data_label = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_vm._v("*自定义标签：{a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）+ 单位（可空）"), _c('br'), _vm._v("如：'{a} <br /> {b} : {c} ({d}%)'")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "图例显示"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.pie.legend_type),
      expression: "form.pie.legend_type"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.pie.legend_type)
    },
    on: {
      "input": function($event) {
        _vm.form.pie.legend_type = $event
      }
    }
  }, _vm._l((_vm.legendType), function(item) {
    return _c('el-option', {
      key: item.type,
      attrs: {
        "label": item.value,
        "value": item.type
      }
    })
  }))])])]), _vm._v(" ")])], true), _vm._v(" "), _vm._v(" "), _c('el-dialog', {
    ref: "layout",
    attrs: {
      "title": "页面布局"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addLayout
    }
  }, [_vm._v("添加布局区")]), _vm._v(" "), _vm._l((_vm.form.display.group), function(group, index) {
    return _c('div', {
      staticClass: "layout-area m-t-10"
    }, [_c('div', {
      staticClass: "layout-header"
    }, [_c('span', [_vm._v("布局：")]), _vm._v(" "), _c('el-radio-group', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.layout),
        expression: "group.layout"
      }],
      domProps: {
        "value": (group.layout)
      },
      on: {
        "input": function($event) {
          group.layout = $event
        }
      }
    }, [_c('el-radio', {
      attrs: {
        "label": 10
      }
    }, [_vm._v("一列")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 20
      }
    }, [_vm._v("两列")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": 30
      }
    }, [_vm._v("三列")])]), _vm._v(" "), (index > 0) ? _c('el-button', {
      staticClass: "delCol",
      attrs: {
        "type": "danger",
        "size": "small"
      },
      on: {
        "click": function($event) {
          _vm.delLayout(index)
        }
      }
    }, [_vm._v("删除")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "drag"
    }, [_c('draggable', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.charts),
        expression: "group.charts"
      }],
      staticClass: "dragArea",
      attrs: {
        "options": {
          group: 'people'
        }
      },
      domProps: {
        "value": (group.charts)
      },
      on: {
        "input": function($event) {
          group.charts = $event
        }
      }
    }, _vm._l((group.charts), function(chart) {
      return _c('div', {
        staticClass: "chart",
        class: {
          'layout10': group.layout == 10,
            'layout20': group.layout == 20,
            'layout30': group.layout == 30,
        }
      }, [_c('i', {
        staticClass: "fa fa-arrows fz-24 c-blue"
      }), _vm._v(" "), _c('span', {
        staticClass: "chartValue"
      }, [_vm._v(_vm._s(chart.value))])])
    }))])])
  })], true), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('el-dialog', {
    ref: "condition",
    attrs: {
      "title": "指标配置"
    }
  }, [(_vm.isOpen) ? _c('el-form', {
    ref: "newTableRow",
    attrs: {
      "label-width": "80px",
      "rules": _vm.rules,
      "model": _vm.newTableRow
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择表单"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTableRow.config.model_id),
      expression: "newTableRow.config.model_id"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.newTableRow.config.model_id)
    },
    on: {
      "change": _vm.changeField,
      "input": function($event) {
        _vm.newTableRow.config.model_id = $event
      }
    }
  }, _vm._l((_vm.tableFormList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "筛选条件",
      "prop": "config"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.newTableRow.config.filter.filter_condition,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "条件名"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.name),
            expression: "scope.row.name"
          }],
          attrs: {
            "placeholder": "条件名"
          },
          domProps: {
            "value": (scope.row.name)
          },
          on: {
            "input": function($event) {
              scope.row.name = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "field_id",
      "label": "选择字段"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.field_id),
            expression: "scope.row.field_id"
          }],
          attrs: {
            "placeholder": "请选择"
          },
          domProps: {
            "value": (scope.row.field_id)
          },
          on: {
            "input": function($event) {
              scope.row.field_id = $event
            }
          }
        }, _vm._l((_vm.tableFieldList), function(item) {
          return _c('el-option', {
            key: item.field_id,
            attrs: {
              "label": item.title,
              "value": item.field_id
            }
          }, [_vm._v("\n                    " + _vm._s(item.title) + "(" + _vm._s(item.field) + ")\n                  ")])
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logic",
      "label": "逻辑"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.logic),
            expression: "scope.row.logic"
          }],
          attrs: {
            "placeholder": "请选择"
          },
          domProps: {
            "value": (scope.row.logic)
          },
          on: {
            "input": function($event) {
              scope.row.logic = $event
            }
          }
        }, _vm._l((_vm.logic), function(item) {
          return _c('el-option', {
            key: item.type,
            attrs: {
              "label": item.value,
              "value": item.type
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value_type",
      "label": "值类型"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.value_type),
            expression: "scope.row.value_type"
          }],
          attrs: {
            "placeholder": "请选择"
          },
          domProps: {
            "value": (scope.row.value_type)
          },
          on: {
            "input": function($event) {
              scope.row.value_type = $event
            }
          }
        }, _vm._l((_vm.tableType), function(item) {
          return _c('el-option', {
            key: item.type,
            attrs: {
              "label": item.value,
              "value": item.type
            }
          })
        }))]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "value",
      "label": "值"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (scope.row.value),
            expression: "scope.row.value"
          }],
          attrs: {
            "placeholder": "值"
          },
          domProps: {
            "value": (scope.row.value)
          },
          on: {
            "input": function($event) {
              scope.row.value = $event
            }
          }
        })]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.deleteRow(scope.$index, _vm.newTableRow.config.filter.filter_condition)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.addTableRow
    }
  }, [_vm._v("添 加")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "条件间逻辑关系"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTableRow.config.filter.relation),
      expression: "newTableRow.config.filter.relation"
    }],
    staticClass: "w-650",
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    domProps: {
      "value": (_vm.newTableRow.config.filter.relation)
    },
    on: {
      "input": function($event) {
        _vm.newTableRow.config.filter.relation = $event
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.checkValid
    }
  }, [_vm._v("检查是否正确")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._v("*说明：为空则全部条件为AND关系，填写条件名和AND、OR以及括号、双引号(均为英文半角)来组合条件间的关系，慎重以免报错，若解析失败，则会以全部为AND来解析。例子：(\"条件名1\"AND\"条件名2\")OR(\"条件名1\"AND\"条件名3\")")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "可调用清单"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.callList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "iden",
      "label": "标识",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "desc",
      "label": "说明",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "example",
      "label": "例子"
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "统计公式"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTableRow.config.formula),
      expression: "newTableRow.config.formula"
    }],
    staticClass: "w-650",
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    domProps: {
      "value": (_vm.newTableRow.config.formula)
    },
    on: {
      "input": function($event) {
        _vm.newTableRow.config.formula = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_vm._v("公式中支持四则运算与括号：+ - * / ()")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveTableRowData
    }
  }, [_vm._v("确 定")])])]), _vm._v(" ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb429d4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/dimensionalChart.vue
// module id = 1978
// module chunks = 2